module.exports = __webpack_public_path__ + "img/check-naranja.39ce3ef6.svg";